var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPrivateEnabled)?_c('span',{staticClass:"badge-private"},[_vm._v("Private")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }